function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module media-embed/mediaregistry
 */
import { TooltipView, IconView, Template } from 'ckeditor5/src/ui';
import { logWarning, toArray } from 'ckeditor5/src/utils';
import mediaPlaceholderIcon from '../theme/icons/media-placeholder.svg';
var mediaPlaceholderIconViewBox = '0 0 64 42';
/**
 * A bridge between the raw media content provider definitions and the editor view content.
 *
 * It helps translating media URLs to corresponding {@link module:engine/view/element~Element view elements}.
 *
 * Mostly used by the {@link module:media-embed/mediaembedediting~MediaEmbedEditing} plugin.
 */

var MediaRegistry = /*#__PURE__*/function () {
  /**
   * Creates an instance of the {@link module:media-embed/mediaregistry~MediaRegistry} class.
   *
   * @param {module:utils/locale~Locale} locale The localization services instance.
   * @param {module:media-embed/mediaembed~MediaEmbedConfig} config The configuration of the media embed feature.
   */
  function MediaRegistry(locale, config) {
    _classCallCheck(this, MediaRegistry);

    var providers = config.providers;
    var extraProviders = config.extraProviders || [];
    var removedProviders = new Set(config.removeProviders);
    var providerDefinitions = providers.concat(extraProviders).filter(function (provider) {
      var name = provider.name;

      if (!name) {
        /**
         * One of the providers (or extra providers) specified in the media embed configuration
         * has no name and will not be used by the editor. In order to get this media
         * provider working, double check your editor configuration.
         *
         * @error media-embed-no-provider-name
         */
        logWarning('media-embed-no-provider-name', {
          provider: provider
        });
        return false;
      }

      return !removedProviders.has(name);
    });
    /**
     * The {@link module:utils/locale~Locale} instance.
     *
     * @member {module:utils/locale~Locale}
     */

    this.locale = locale;
    /**
     * The media provider definitions available for the registry. Usually corresponding with the
     * {@link module:media-embed/mediaembed~MediaEmbedConfig media configuration}.
     *
     * @member {Array}
     */

    this.providerDefinitions = providerDefinitions;
  }
  /**
   * Checks whether the passed URL is representing a certain media type allowed in the editor.
   *
   * @param {String} url The URL to be checked
   * @returns {Boolean}
   */


  _createClass(MediaRegistry, [{
    key: "hasMedia",
    value: function hasMedia(url) {
      return !!this._getMedia(url);
    }
    /**
     * For the given media URL string and options, it returns the {@link module:engine/view/element~Element view element}
     * representing that media.
     *
     * **Note:** If no URL is specified, an empty view element is returned.
     *
     * @param {module:engine/view/downcastwriter~DowncastWriter} writer The view writer used to produce a view element.
     * @param {String} url The URL to be translated into a view element.
     * @param {Object} options
     * @param {String} [options.elementName]
     * @param {Boolean} [options.renderMediaPreview]
     * @param {Boolean} [options.renderForEditingView]
     * @returns {module:engine/view/element~Element}
     */

  }, {
    key: "getMediaViewElement",
    value: function getMediaViewElement(writer, url, options) {
      return this._getMedia(url).getViewElement(writer, options);
    }
    /**
     * Returns a `Media` instance for the given URL.
     *
     * @protected
     * @param {String} url The URL of the media.
     * @returns {module:media-embed/mediaregistry~Media|null} The `Media` instance or `null` when there is none.
     */

  }, {
    key: "_getMedia",
    value: function _getMedia(url) {
      if (!url) {
        return new Media(this.locale);
      }

      url = url.trim();

      var _iterator = _createForOfIteratorHelper(this.providerDefinitions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var definition = _step.value;
          var previewRenderer = definition.html;
          var pattern = toArray(definition.url);

          var _iterator2 = _createForOfIteratorHelper(pattern),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var subPattern = _step2.value;

              var match = this._getUrlMatches(url, subPattern);

              if (match) {
                return new Media(this.locale, url, match, previewRenderer);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    }
    /**
     * Tries to match `url` to `pattern`.
     *
     * @private
     * @param {String} url The URL of the media.
     * @param {RegExp} pattern The pattern that should accept the media URL.
     * @returns {Array|null}
     */

  }, {
    key: "_getUrlMatches",
    value: function _getUrlMatches(url, pattern) {
      // 1. Try to match without stripping the protocol and "www" subdomain.
      var match = url.match(pattern);

      if (match) {
        return match;
      } // 2. Try to match after stripping the protocol.


      var rawUrl = url.replace(/^https?:\/\//, '');
      match = rawUrl.match(pattern);

      if (match) {
        return match;
      } // 3. Try to match after stripping the "www" subdomain.


      rawUrl = rawUrl.replace(/^www\./, '');
      match = rawUrl.match(pattern);

      if (match) {
        return match;
      }

      return null;
    }
  }]);

  return MediaRegistry;
}();
/**
 * Represents media defined by the provider configuration.
 *
 * It can be rendered to the {@link module:engine/view/element~Element view element} and used in the editing or data pipeline.
 *
 * @private
 */


export { MediaRegistry as default };

var Media = /*#__PURE__*/function () {
  function Media(locale, url, match, previewRenderer) {
    _classCallCheck(this, Media);

    /**
     * The URL this Media instance represents.
     *
     * @member {String}
     */
    this.url = this._getValidUrl(url);
    /**
     * Shorthand for {@link module:utils/locale~Locale#t}.
     *
     * @see module:utils/locale~Locale#t
     * @method
     */

    this._t = locale.t;
    /**
     * The output of the `RegExp.match` which validated the {@link #url} of this media.
     *
     * @member {Object}
     */

    this._match = match;
    /**
     * The function returning the HTML string preview of this media.
     *
     * @member {Function}
     */

    this._previewRenderer = previewRenderer;
  }
  /**
   * Returns the view element representation of the media.
   *
   * @param {module:engine/view/downcastwriter~DowncastWriter} writer The view writer used to produce a view element.
   * @param {Object} options
   * @param {String} [options.elementName]
   * @param {Boolean} [options.renderMediaPreview]
   * @param {Boolean} [options.renderForEditingView]
   * @returns {module:engine/view/element~Element}
   */


  _createClass(Media, [{
    key: "getViewElement",
    value: function getViewElement(writer, options) {
      var attributes = {};
      var viewElement;

      if (options.renderForEditingView || options.renderMediaPreview && this.url && this._previewRenderer) {
        if (this.url) {
          attributes['data-oembed-url'] = this.url;
        }

        if (options.renderForEditingView) {
          attributes.class = 'ck-media__wrapper';
        }

        var mediaHtml = this._getPreviewHtml(options);

        viewElement = writer.createRawElement('div', attributes, function (domElement) {
          domElement.innerHTML = mediaHtml;
        });
      } else {
        if (this.url) {
          attributes.url = this.url;
        }

        viewElement = writer.createEmptyElement(options.elementName, attributes);
      }

      writer.setCustomProperty('media-content', true, viewElement);
      return viewElement;
    }
    /**
     * Returns the HTML string of the media content preview.
     *
     * @param {module:engine/view/downcastwriter~DowncastWriter} writer The view writer used to produce a view element.
     * @param {Object} options
     * @param {Boolean} [options.renderForEditingView]
     * @returns {String}
     */

  }, {
    key: "_getPreviewHtml",
    value: function _getPreviewHtml(options) {
      if (this._previewRenderer) {
        return this._previewRenderer(this._match);
      } else {
        // The placeholder only makes sense for editing view and media which have URLs.
        // Placeholder is never displayed in data and URL-less media have no content.
        if (this.url && options.renderForEditingView) {
          return this._getPlaceholderHtml();
        }

        return '';
      }
    }
    /**
     * Returns the placeholder HTML when the media has no content preview.
     *
     * @returns {String}
     */

  }, {
    key: "_getPlaceholderHtml",
    value: function _getPlaceholderHtml() {
      var tooltip = new TooltipView();
      var icon = new IconView();
      tooltip.text = this._t('Open media in new tab');
      icon.content = mediaPlaceholderIcon;
      icon.viewBox = mediaPlaceholderIconViewBox;
      var placeholder = new Template({
        tag: 'div',
        attributes: {
          class: 'ck ck-reset_all ck-media__placeholder'
        },
        children: [{
          tag: 'div',
          attributes: {
            class: 'ck-media__placeholder__icon'
          },
          children: [icon]
        }, {
          tag: 'a',
          attributes: {
            class: 'ck-media__placeholder__url',
            target: '_blank',
            rel: 'noopener noreferrer',
            href: this.url
          },
          children: [{
            tag: 'span',
            attributes: {
              class: 'ck-media__placeholder__url__text'
            },
            children: [this.url]
          }, tooltip]
        }]
      }).render();
      return placeholder.outerHTML;
    }
    /**
     * Returns the full URL to the specified media.
     *
     * @param {String} url The URL of the media.
     * @returns {String|null}
     */

  }, {
    key: "_getValidUrl",
    value: function _getValidUrl(url) {
      if (!url) {
        return null;
      }

      if (url.match(/^https?/)) {
        return url;
      }

      return 'https://' + url;
    }
  }]);

  return Media;
}();